const PATHNAME = {
  DEFAULT: {
    SLUG_SEPARATOR: '/',
    TIMEZONE: 'Asia/Tehran',
    LOCALE: 'fa-IR',
  },
  LOCAL: {
    HOME: {
      BASE_URL: '/',
    },
    PRODUCTS: {
      BASE_URL: '/products/',
      CREATE_URL: 'create-product',
      UPDATE_URL: 'update-product',
    },
    CATEGORIES: {
      BASE_URL: '/categories/',
      CREATE_URL: 'create-category',
      UPDATE_URL: 'update-category',
    },
    TAGS: {
      BASE_URL: '/tags/',
      CREATE_URL: 'create-tag',
      UPDATE_URL: 'update-tag',
    },
    BRANDS: {
      BASE_URL: '/brands/',
      CREATE_URL: 'create-brand',
      UPDATE_URL: 'update-brand',
    },
    CATALOGS: {
      BASE_URL: '/catalogs/',
      CREATE_URL: 'create-catalog',
      UPDATE_URL: 'update-catalog',
    },
    ATTRIBUTES: {
      BASE_URL: '/attributes/',
      CREATE_URL: 'create-attribute',
      UPDATE_URL: 'update-attribute',
    },
    PACKAGING_MODELS: {
      BASE_URL: '/packaging-models/',
      CREATE_URL: 'create-packaging-model',
      UPDATE_URL: 'update-packaging-model',
    },
    PACKAGES: {
      BASE_URL: '/packages/',
      CREATE_URL: 'create-package',
      UPDATE_URL: 'update-package',
    },
    PURCHASES: {
      BASE_URL: '/purchases/',
      UPDATE_URL: 'update-purchase',
    },
    PAYMENT_GATEWAYS: {
      BASE_URL: '/payment-gateways/',
      UPDATE_URL: 'update-payment-gateway',
    },
    SHIPPING_CONFIGS: {
      BASE_URL: '/shipping-configs/',
      CREATE_URL: 'create-shipping-config',
      UPDATE_URL: 'update-shipping-config',
    },
    USERS: {
      BASE_URL: '/users/',
      CREATE_URL: 'create-user',
      UPDATE_URL: 'update-user',
    },
    ROLES: {
      BASE_URL: '/roles/',
      CREATE_URL: 'create-role',
      UPDATE_URL: 'update-role',
    },
    PRODUCTS_COMMENTS: {
      BASE_URL: '/products-comments/',
      CREATE_URL: 'create-product-comment',
      UPDATE_URL: 'update-product-comment',
    },
    DISCOUNT_CODES: {
      BASE_URL: '/discount-codes/',
      CREATE_URL: 'create-discount-code',
      UPDATE_URL: 'update-discount-code',
    },
    SPECIAL_OFFERS: {
      BASE_URL: '/special-offers/',
      CREATE_URL: 'create-special-offer',
      UPDATE_URL: 'update-special-offer',
    },
    PRODUCTS_REPORT: {
      BASE_URL: '/products-export/',
    },
    PRODUCTS_IMPORT: {
      BASE_URL: '/products-import/',
    },
    MARKETING: {
      BASE_URL: '/marketing/',
    },
    PRODUCTS_EDIT: {
      BASE_URL: '/products-edit/',
    },
    SEO_SETTING: {
      BASE_URL: '/seo-setting/',
    },
    WATERMARK_SETTING: {
      BASE_URL: '/watermark-setting/',
    },
    PUBLIC_NOTICES: {
      BASE_URL: '/public-notices/',
    },
    PAGE_BUILDER: {
      BASE_URL: '/page-builder/',
    },
    PAGE_BUILDER_FOOTER: {
      BASE_URL: '/page-builder-footer/',
    },
    LOGIN: {
      BASE_URL: '/login/',
    },
    PRODUCT: {
      BASE_URL: '/product/',
    },
    CATEGORY: {
      BASE_URL: '/category/',
    },
    TAG: {
      BASE_URL: '/tag/',
    },
    BRAND: {
      BASE_URL: '/brands/',
    },
    CATALOG: {
      BASE_URL: '/catalog/',
    },
    SITEMAP: {
      BASE_URL: 'sitemap',
      SUFFIX: '_index',
      EXTENSION: '.xml',
    },
  },
  QUERY_PARAM: {
    DEFAULT: {
      LOGIN_TYPE: 'OTP',
      SORT_TYPE: 'Newest',
      QUESTION_MARK: '?',
      ASSIGNMENT: '=',
      AMPERSAND: '&',
      PIPELINE: '|',
      AT_SIGN: '@',
      COLON: ':',
      COMMA: ',',
      SPACE: ' ',
      PLUS: '+',
      HASH: '#',
      DOT: '.',
      PAGE_SIBLING: 0,
      PAGE_NUMBER: 1,
      PAGE_SIZE: 10,
      MAX_PAGE_SIZE: 150,
      SITEMAP_SIZE: 5_000,
    },
    ID: {
      BASE_URL: 'id',
    },
    TYPE: {
      BASE_URL: 'type',
    },
    CULTURE: {
      BASE_URL: 'culture',
    },
    STATUSES: {
      BASE_URL: 'statuses',
    },
    SORT_TYPE: {
      BASE_URL: 'sort-type',
    },
    SEARCH_KEY: {
      BASE_URL: 'search-key',
    },
    PAGE_SIZE: {
      BASE_URL: 'page-size',
    },
    PAGE_NUMBER: {
      BASE_URL: 'page-number',
    },
    BRANDS_IDS: {
      BASE_URL: 'brands-ids',
    },
    CATEGORIES_IDS: {
      BASE_URL: 'categories-ids',
    },
    CALL_FOR_PRICE: {
      BASE_URL: 'call-for-price',
    },
  },
} as const;

export { PATHNAME };
